declare global {
  // tslint:disable-next-line
  interface Window {
    google: any
  }
}

type FunctionType = (...args: any[]) => any
interface IActionCreatorsMapObject {
  [actionCreator: string]: FunctionType
}
export type ActionsUnion<A extends IActionCreatorsMapObject> = ReturnType<A[keyof A]>

export * from './integration'
export * from './vehicle'
export * from './organization'
export * from './driver'
export * from './assistance'
export * from './common'
export * from './driver'
export * from './global-settings'
export * from './location'
export * from './membership'
export * from './mobility'
export * from './organization'
export * from './payment'
export * from './program-service'
export * from './provider'
export * from './provider-product'
export * from './rider'
export * from './rider-trip'
export * from './service'
export * from './service-pricing'
export * from './settings'
export * from './state'
export * from './team-member'
export * from './station-user'
export * from './trip'
export * from './trip-menu-service'
export * from './user'
export * from './goinzone'
export * from './google-map'
export * from './promotions'
export * from './subscriptions'
export * from './station-user-trips'
export * from './team-member-permission'
export * from './import-template'
export * from './trip-summary'
export * from './desginated-hotspot'
export * from './route-optimization'



// WEBPACK FOOTER //
// ./src/types/index.ts